import { render, staticRenderFns } from "./ClinicalObservationsList.vue?vue&type=template&id=689dd36e"
import script from "./ClinicalObservationsList.vue?vue&type=script&lang=ts"
export * from "./ClinicalObservationsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports